require('./loanInsuraceDetail.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ CC Components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class LoanInsuraceDetail extends React.Component {

    buildHasInsuranceContent() {
        const { insurance } = this.props;
        return insurance ? (
            <div className="loan-insurance-detail__content">
                <div className="loan-insurance-detail__content-text">
                    {formatText('loanInsuranceDetail-loanInsuranceDetailsSubtitle')}
                </div>
                <i className="loan-insurance-detail__content-icon icon icon-insurances-home" />
                <div className="loan-insurance-detail__content-name">
                    {insurance.title}
                </div>
                <div className="loan-insurance-detail__content-link">
                    <Link to={insurance.link} className="insurances-list-card-item__link">
                        <FormattedText
                            className="insurances-list-card-item__link-text"
                            value="loanInsuranceDetail-loanInsuranceLink"
                        />
                    </Link>
                </div>
            </div>
        ) : null;
    }

    buildHasInsuranceMessage() {
        return (
            <OKMessage
                type="informative"
            >
                <FormattedText value={'loanInsuranceDetail-loanInsuranceDetailAlert'} />
            </OKMessage>
        )
    }

    buildHasNoInsuranceMessage() {
        return (
            <OKMessage type="informative">
                <FormattedText value={'loanInsuranceDetail-loanInsuranceDetail_hasNotInsuranceMessage'} />
            </OKMessage>
        )
    }

    buildHasNoInsuranceMessageCC() {
        return (
            <BlockInfo>
                <FormattedText value={'cc_loanInsuranceDetail-loanInsuranceDetail_hasNotInsuranceMessage'} />
            </BlockInfo>
        )
    }

    render() {
        const { insurance } = this.props;
        const hasNoInsurancemessage = __CONTACT_CENTER__ ? this.buildHasNoInsuranceMessageCC() : this.buildHasNoInsuranceMessage();
        const insuranceMessage = insurance ? this.buildHasInsuranceMessage() : hasNoInsurancemessage;
        return (
            <OKSectionBox
                className="loan-insurance-detail">
                <article>
                    <OKBoxTitle
                        value={formatText('loanInsuranceDetail-loanInsuranceDetailsTitle')}
                    />
                </article>
                {this.buildHasInsuranceContent()}
                <div className="loan-insurance-detail__message">
                    {insuranceMessage}
                </div>
            </OKSectionBox>
        );
    }
}

LoanInsuraceDetail.propTypes = {
    insurance: PropTypes.object.isRequired
}

module.exports = LoanInsuraceDetail;
